export enum AppointmentStatusResolver {
  RESCHEDULED = 'RESCHEDULED',
  SCHEDULED = 'SCHEDULED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  'NO-SHOW' = 'NO_SHOW',
}
